import { createStore, applyMiddleware, compose } from "redux";
import { rootReducer } from "./../reducers";
import thunk from "redux-thunk";

// This is for redux dev tools in Chrome
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);
